<template>
    <form class="form" @submit.prevent="onSubmit">
        <transition name="trs-simple-fade" mode="out-in">
            <div v-if="wasSent" key="success">
                <slot name="success"/>
            </div>
            <div v-else key="main">
                <!--this p should never be printed but we will put it here because we don't trust the server responses-->
                <p class="ajax-form--error" v-if="genericErrorMessage">{{ genericErrorMessage }}</p>
                <slot name="main"
                        :is-loading="isLoading"
                        :get-field-messages-by-name="getFieldMessagesByName"
                        :on-submit="onSubmit"/>

            </div>
        </transition>
    </form>
</template>

<script>
    import axios from 'util/service';
    import bemMixin from 'framework/mixins/bem';

    export default {
        mixins: [bemMixin('ajax-form')],
        props: {
            action: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                hasErrors: false,
                isLoading: false,
                errors: [],
                genericErrorMessage: null,
                wasSent: false,
            };
        },
        methods: {
            onSuccess({ data }) {
                if (data.success_url) {
                    window.location.href = data.success_url;
                } else {
                    this.wasSent = true;
                    this.hasErrors = false;
                }
            },
            onFail(error) {
                const { response } = error;

                if (response && response.data && response.data.errors) {
                    this.errors = response.data.errors;
                    this.genericErrorMessage = null;
                } else if (response && response.data && response.data.error) {
                    this.genericErrorMessage = response.data.error;
                } else {
                    this.genericErrorMessage = error.message;
                }

                this.hasErrors = true;


                return Promise.reject(error);
            },
            onDone() {
                this.isLoading = false;
            },
            getFieldMessagesByName(name) {
                if (this.errors) {
                    return this.errors[name] ? {
                        error: this.errors[name].map(error => error.message),
                    } : {};
                }

                return {};
            },
            onSubmit() {
                if (this.isLoading) {
                    return;
                }

                const formData = new FormData(this.$el);
                this.isLoading = true;

                axios.post(this.action, formData, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        HTTP_ACCEPT: 'application/json',
                    },
                })
                    .then(this.onSuccess)
                    .then(this.onDone)
                    .catch(this.onFail)
                    .catch(this.onDone);
            },
        },
    };
</script>
